import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { MessagingChannelReplyMode } from '@treadinc/horizon-api-spec';
import { ReactNode } from 'react';

import { MessagingChannel } from '~hooks/useMessaging/models';
import MessagingChannelSubtitle from '~pages/Messages/components/MessagingChannelSubtitle';
import {
  messagingReplyModeTag,
  messagingTargetChannelSubtitle,
} from '~pages/Messages/messagingChannelLabels';
import { Nullable } from '~types/Nullable';

type TargetMessagingHeaderProps = {
  avatar: ReactNode;
  channel: Nullable<MessagingChannel>;
  endAction?: ReactNode;
  replyMode?: MessagingChannelReplyMode;
  subtitle: string;
  title: string;
};

export default function TargetMessagingHeader({
  avatar,
  channel,
  endAction,
  replyMode,
  subtitle,
  title,
}: TargetMessagingHeaderProps) {
  const theme = useTheme();

  return (
    <Box
      data-test-id="target-messaging-header"
      sx={{
        alignItems: 'center',
        backgroundColor: theme.semantic.surface,
        borderBottom: `1px solid ${theme.semantic.divider}`,
        display: 'flex',
        flexShrink: 0,
        gap: 1.25,
        px: 2,
        py: 1,
      }}
    >
      {avatar}

      <Box
        sx={{
          alignItems: 'flex-start',
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          minWidth: 0,
        }}
      >
        <Typography noWrap sx={{ maxWidth: '100%' }} variant="h6">
          {title}
        </Typography>
        <MessagingChannelSubtitle
          channel={channel}
          label={messagingTargetChannelSubtitle(subtitle, channel)}
        />
      </Box>

      {replyMode && (
        <Chip label={messagingReplyModeTag(replyMode)} size="small" variant="outlined" />
      )}

      {endAction}
    </Box>
  );
}
